// extracted by mini-css-extract-plugin
module.exports = {"root":"FormMessage_root__WA_wP","errorVariant":"FormMessage_errorVariant__OE5jt"};